import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from "../api/axiosInstance";

const API_URL = '/api/v1/get-in-touch';

// CREATE Inquiry
export const createInquiry = createAsyncThunk(
  'getInTouch/createInquiry',
  async (formData, { rejectWithValue }) => {
    try {
      const res = await axios.post(API_URL, formData);
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

// FETCH all Inquiries
export const fetchInquiries = createAsyncThunk(
  'getInTouch/fetchInquiries',
  async (_, { rejectWithValue }) => {
    try {
      const res = await axios.get(API_URL);
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

// DELETE Inquiry by ID
export const deleteInquiry = createAsyncThunk(
  'getInTouch/deleteInquiry',
  async (id, { rejectWithValue }) => {
    try {
      await axios.delete(`${API_URL}/${id}`);
      return id;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

// UPDATE Inquiry by ID
export const updateInquiry = createAsyncThunk(
  'getInTouch/updateInquiry',
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await axios.put(`${API_URL}/${id}`, data);
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

const getInTouchSlice = createSlice({
  name: 'getInTouch',
  initialState: {
    inquiries: [],
    loading: false,
    error: null,
    success: false,
  },
  reducers: {
    clearInquiryState: (state) => {
      state.success = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // CREATE
      .addCase(createInquiry.pending, (state) => {
        state.loading = true;
      })
      .addCase(createInquiry.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.inquiries.unshift(action.payload);
      })
      .addCase(createInquiry.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // FETCH
      .addCase(fetchInquiries.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchInquiries.fulfilled, (state, action) => {
        state.loading = false;
        state.inquiries = action.payload;
      })
      .addCase(fetchInquiries.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // DELETE
      .addCase(deleteInquiry.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteInquiry.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.inquiries = state.inquiries.filter(
          (inquiry) => inquiry._id !== action.payload
        );
      })
      .addCase(deleteInquiry.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // UPDATE
      .addCase(updateInquiry.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateInquiry.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.inquiries = state.inquiries.map((inquiry) =>
          inquiry._id === action.payload._id ? action.payload : inquiry
        );
      })
      .addCase(updateInquiry.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearInquiryState } = getInTouchSlice.actions;
export default getInTouchSlice.reducer;
